export default __webpack_public_path__ + "static/media/graph-down.97c632e8.svg";